module.exports = __webpack_public_path__ + "img/like-1.8abe6c3f.svg";